import React from 'react';
import { Box, Button, CircularProgress } from '@material-ui/core';

const PRIMARY = '#c4122f';

export const outlinedRedBtn: React.CSSProperties = { fontWeight: 700, borderColor: PRIMARY, color: PRIMARY };

interface StepButtonBarProps {
    onCancel: () => void;
    onBack?: () => void;
    onNext: () => void;
    nextLabel: string;
    nextDisabled?: boolean;
    isLoading?: boolean;
    showBack?: boolean;
    formatMessage: any;
    isDeleteStep?: boolean;
}

export const StepButtonBar = ({
    onCancel,
    onBack,
    onNext,
    nextLabel,
    nextDisabled = false,
    isLoading = false,
    showBack = true,
    formatMessage,
    isDeleteStep = false,
}: StepButtonBarProps) => {
    const deleteStyle = isDeleteStep ? { backgroundColor: PRIMARY, color: 'white', borderColor: PRIMARY } : outlinedRedBtn;

    return (
        <Box style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
            <Box style={{ display: 'flex', gap: '8px' }}>
                <Button
                    variant={isDeleteStep ? 'contained' : 'outlined'}
                    onClick={onNext}
                    disabled={nextDisabled || isLoading}
                    style={{ ...deleteStyle, minWidth: '140px' }}
                >
                    {isLoading ? <CircularProgress size={20} /> : formatMessage({ id: nextLabel })}
                </Button>
            </Box>
        </Box>

    );
};
